// kluntje events
export const MQ_CHANGE_EVENT = "kl-mq-change";
export const IN_VIEWPORT_EVENT = "kl-in-vp";
export const OUT_VIEWPORT_EVENT = "kl-out-vp";

// events
export const AEM_MODE_CHANGE = "sde-aem-mode-change";
export const IMAGE_LOAD = "sde-image-load";
export const IMAGE_LOADED = "vup-image-loaded";
export const PAGINATION_CHANGED = "sde-pagination-changed";
export const TAB_CHANGED_EVENT = "sde-tab-changed";
export const FILTER_CHANGED = "sde-filter-changed";
export const CATEGORY_CHANGED = "sde-category-changed";
export const COMPONENT_RESET = "sde-component-reset";
export const EVENT_AEM_MODE_CHANGE = "sde-aem-mode-changed";
export const MAP_LOADED_EVENT = "sde-map-loaded";
export const OVERLAY_CLOSED = "sde-overlay-closed";
export const STATE_CHANGED = "sde-state-changed";
export const MAP_ACTIVE_MARKER_CHANGED_EVENT = "sde-active-marker-changed";
export const FUNDING_SEARCH_OVERVIEW_ACTIVE_EVENT = "sde-funding-search-overview-active";
export const FUNDING_SEARCH_DETAILS_ACTIVE_EVENT = "sde-funding-search-details-active";
export const QUESTIONNAIRE_STEP_AVAILABLE_CHANGE_EVENT = "sde-questionnaire-step-available-change";
export const QUESTIONNAIRE_STEP_SUBMIT = "sde-questionnaire-step-submit";
export const QUESTIONNAIRE_STEP_CHANGE = "sde-questionnaire-step-change";
export const PARTNER_LOGIN_OVERLAY_LOADING = "sde-partner-login-overlay-loading";
export const BOOKMARKING_OVERLAY_LOADING = "sde-bookmarking-overlay-loading";
export const HEADER_HEIGHT_CHANGED = "sde-header-height-changed";
export const GALLERY_INDEX_CHANGE = "sde-gallery-index-change";

// generic events should never be bubbled
export const GENERIC_CHANGE_EVENT = "sde-generic-change";
export const GENERIC_LOADING_CHANGE_EVENT = "sde-generic-loading-change";
export const GENERIC_VALIDATION_CHANGE_EVENT = "sde-generic-validation-change";
export const GENERIC_RESET_EVENT = "sde-generic-reset";
export const GENERIC_CLOSED_EVENT = "sde-generic-closed";
export const GENERIC_SUCCESS_EVENT = "sde-generic-success";
export const GENERIC_ERROR_EVENT = "sde-generic-error";
export const GENERIC_VALIDATION_ERROR_EVENT = "sde-generic-validation-error";
export const GENERIC_FINISHED_EVENT = "sde-generic-finished";
export const GENERIC_SUBMIT_EVENT = "sde-generic-submit";
export const GENERIC_INIT_EVENT = "sde-generic-init";

export const VIDEO_LOADED = "sde-video-loaded";
// Form Events
export const CHECKED_EVENT = "sde-form-field-checked";
export const CHANGED_EVENT = "sde-form-field-changed";
export const SELECTION_CHANGED_EVENT = "sde-form-field-checked";
export const SEARCH_INPUT_SUBMIT_EVENT = "sde-search-input-submit";
export const FORM_STEP_VALID = "sde-form-step--valid";
export const FORM_STEP_BACK = "sde-form-step--back";
